module.exports = __webpack_public_path__ + "static/media/usericon.fe263222.svg";